export enum campaignStates {
  "PAUSED" = "PAUSED",
  "ENABLED" = "ENABLED",
  "ARCHIVED" = "ARCHIVED",
}

export type iAsin = {
  forScrape: boolean
  asin: string
}

export enum currencyCode {
  "USD" = "USD",
}
